import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	none: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.date-field.none',
		defaultMessage: 'None',
		description: 'Label for absent value for either start or due date',
	},
	startDate: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.date-field.start-date',
		defaultMessage: 'Start date',
		description: 'Label for the start date of an epic',
	},
	dueDate: {
		id: 'software-backlog-panel.epic.epic-panel.epic-card-list.epic-card.card-contents.date-field.due-date',
		defaultMessage: 'Due date',
		description: 'Label for the due date of an epic',
	},
});
